import { MealPlannerRoot } from '../index.d';

export const getMealPlanner = (state: MealPlannerRoot) => state.mealPlanner;
